export const filterSucursales = (sucursalFiltradaArray, suc) => {
  const sucursalFiltrada = suc.filter((sucursal) =>
    sucursalFiltradaArray?.some((sucu) => sucu.id === sucursal.id)
  );
  return sucursalFiltrada;
};
